<template>
  <div>
    <top-header :type="3" :isShow="false" :bgColor="bgColor" :textColor="textColor" />
    <div class="detail_img">
      <div class="detail_con ">
        <div class="pad_top"></div>
        <div class="inner m_flex_box flex_vc flex_jz">
          <img v-lazy="info.logo" alt="" />
          <div class="left flex_v flex_jz">
            <h3 class="line_comp">{{ info.name }}</h3>
            <p>从业经验：{{ info.popularity }}年</p>
            <p class="line_comp2 line_comp3">所属公司: {{ info.decorationCompanyName }}</p>
            <p class="m_flex_box flex_vc line"
              @click="clickOn(info.name, info.decorationCompanyName, info.decorationCompanyId)">
              <span class="">预约设计</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="line-sty"></div>
    <div>
      <div class="detail_con line-word">设计师简介</div>
      <div class="detail_con line-dec">
        {{ info.description }}
      </div>
    </div>
    <div class="line-sty"></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="detail_con line-word">相关案例</div>
      <div class="no_data" v-if="!info.decorationDemoList.length">
        <img src="@/assets/img/nodata.png" alt="">
      </div>
      <div class="list_con new_list">
        <div class="detail_con">
          <div class="m_flex_box flex_jz flex_wrap">
            <div class="inner m_flex_box flex_vc flex_jz flex_column" v-for="(item, index) in info.decorationDemoList"
              :key="index" @click="toDetail(item.id, item.decorationUserId)">
              <img class="new_img" v-lazy="item.logo" alt="" />
              <div class="left_new flex_v flex_jz">
                <h3 class="line_comp">
                  <span>{{ item.title }} </span>
                  <span>{{ item.areaType }} </span>
                </h3>
                <p class="m_flex_box flex_vc line">
                  <span class="">设计师：{{ info.name }}</span>
                  <span class="">{{ item.styleType }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  name: 'teamDetail',
  data() {
    return {
      bgColor: 'transparent',
      textColor: '#fff',
      info: {
        decorationDemoList: []
      },
      id: this.$route.query.id,
      listPage: 1,
      loading: false,
      finished: false,
      value: "",
      timer: null,
      pzshow: false
    };
  },
  components: {
    topHeader,
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    clickOn(type, v, h) {
      this.$router.push({
        path: "/fixtures",
        query: {
          name: type,
          companyName: v,
          companyId: h,
        }
      });
    },
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.offsetTop - (document.documentElement.clientWidth / 7.5) * 0.9) {
        this.showPad = true
      } else {
        this.showPad = false
      }
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = '#000';
        this.bgColor = '#fff';
      } else {
        this.textColor = '#fff';
        this.bgColor = 'transparent';
      }
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$request_again.post('/decoration/user/byId', qs.stringify({
          id: this.id
        })
        )
          .then(res => {
            if (res.success) {
              this.info = res.result;
              this.loading = false;
              this.finished = true;
            } else {
              this.finished = true;
            }
          });
      }
    },
    toDetail(id, userId) {
      this.$router.push({
        path: "/caseDetail",
        query: { id: id, userId: userId }
      });
    }
  },
};
</script>
<style lang="less" scoped>
.detail_img {
  background-size: cover;
  background-image: url("../../assets/img/zxbg.jpg");
}

.line-sty {
  border: 5px solid #f5f5f5
}

.line-word {
  padding: 0.3rem 0;
  font-size: 0.3rem;
  font-weight: 900;
}

.line-dec {
  text-indent: 10px;
  padding-bottom: 0.3rem;
  font-size: 0.26rem;

}

.line_comp {
  font-weight: 900;
  font-size: 0.35rem;
  padding: 0.1rem 0;
}

.detail_con {
  width: 7.04rem;
  margin: 0 auto;

  .flex_column {
    flex-direction: column;
    width: 48%;

    .new_img {
      width: 100%;
      height: 2.55rem;
      object-fit:cover;
      border-radius: 5px 5px 0 0;

      p {
        font-size: 0.3rem;
      }
    }
  }

  .pad_top {
    padding-top: 1.1rem;
  }

  .flex_wrap {
    flex-wrap: wrap
  }

  .inner {
    padding: 0.4rem 0;

    .left {
      width: 4.25rem;
      height: 2.98rem;
      color: #fff;

      h4 {
        height: 0.88rem;
        font-size: 0.28rem;
        color: #202020;
        line-height: 0.44rem;
      }

      p:first-child {
        font-size: 0.32rem;
        font-weight: 600;
      }

      .line {
        display: flex;

        span {
          margin-right: 0.5rem;
          padding: 0.1rem 0.4rem;
          border-radius: 5px;
          color: #fff;
          font-weight: 500;
          font-size: 0.25rem;
          background-color: #2f72f5;
        }
      }

      .line_comp3 {
        -webkit-line-clamp: 2;
      }
    }

    img {
      width: 2.54rem;
      height: 3.08rem;
      object-fit: cover;
    }


  }


}

.new_list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .inner {
    width: 46%;
    border-radius: 5px 5px 0 0;

    .left_new {
      width: 100%;

      .line_comp {
        display: flex;
        justify-content: space-around;

        span {
          width: 48%;
          text-align: center;
          font-size: 0.26rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .line {
        justify-content: space-around;
      }
    }
  }
}
</style>